// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { FileAttachment_abstract } from './../abstract/SagaBase/FileAttachment_abstract';
export class FileAttachment extends FileAttachment_abstract {}
